module.exports = __webpack_public_path__ + "img/4-2-1-2-5-preview-SnackPack-CelineTan-e.911914f9.jpg";